import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Sign in with the new one.");
      navigate("/login");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--peak-bg)] flex items-center justify-center p-6" data-testid="reset-page">
      <div className="max-w-md w-full bg-white border-2 border-[var(--peak-ink)] p-8">
        <div className="section-label">Reset password</div>
        <h1 className="font-heading font-black text-3xl tracking-tighter uppercase mt-1">Pick a new one.</h1>
        {!token && <div className="mt-4 text-sm text-[#E50000]">Missing reset token — request a new link.</div>}
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <div>
            <label className="section-label">New password</label>
            <input required type="password" minLength={6} data-testid="reset-password" className="brutalist-input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div>
            <label className="section-label">Confirm</label>
            <input required type="password" minLength={6} data-testid="reset-confirm" className="brutalist-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full bg-[var(--peak-accent)] hover:bg-black text-white font-bold uppercase tracking-widest px-6 py-3 disabled:opacity-60">
            {loading ? "Updating…" : "Set new password"}
          </button>
          <div className="text-sm"><Link to="/login" className="font-bold underline hover:text-[var(--peak-accent)]">Back to sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
